import { ComponentClass } from "react";
import BaseLightbox, { ILightBoxProps } from "react-image-lightbox-rotate";

import "react-image-lightbox/style.css";

export * from "react-image-lightbox-rotate";

export const Lightbox = BaseLightbox as any as ComponentClass<ILightBoxProps, any>;

export default Lightbox;
